import { Button, ButtonProps } from "@mantine/core"

interface CustomButtonProps extends ButtonProps {
  children: React.ReactElement | React.ReactElement[] | string;
  href?: string;
  onClick?: () => void;
  type?: "submit" | "reset" | "button" | undefined;
}

const CustomButton = ({ onClick, children, type, ...props }: CustomButtonProps) => (
  <Button
    onClick={onClick}
    type={type}
    {...props}
  >
    {children}
  </Button>
)

export default CustomButton;